// removed by extract-text-webpack-plugin
module.exports = {"BORDER_GREY":"#CFD0D2","LIGHT_GREEN":"#C1DB7E","LIGHT_GREY":"#e0e0e0","ERROR_RED":"#e66d4d","CONFIRM_GREEN":"#6EBE45"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvancedFilter/style.css
// module id = 179
// module chunks = 0